import { render, staticRenderFns } from "./ExternalShareLink.vue?vue&type=template&id=124255fe"
import script from "./ExternalShareLink.vue?vue&type=script&lang=js"
export * from "./ExternalShareLink.vue?vue&type=script&lang=js"
import style0 from "./ExternalShareLink.vue?vue&type=style&index=0&lang=postcss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports